import React from 'react';
import '../../scss/components/Checkboxes.scss';
import '../../scss/components/SingleCheckbox.scss';

interface CheckboxesProps {
    onChange?:any,
    onOtherChange?:any,
    name:string,
    className?:string,
    wrapperClassName?:string,
    label?:string,
    labelPosition?:string,
    options:Array<{
        value: string,
        label: string
    }>,
    other?:{
        value: string,
        label: string
    },
    value?:Array<any>,
    error?:string
    description?:string
}
const Checkboxes = ({
    onChange,
    onOtherChange,
    name,
    className,
    wrapperClassName,
    label,
    labelPosition = 'before',
    options,
    other,
    value,
    error,
    description
}:CheckboxesProps) => {
    return (
        <div className={`form-group checkboxes${wrapperClassName ? ' ' + wrapperClassName : ''} ${ !label || label.length <= 0 ? ' no-label' : '' }`}>
            {label && label.length > 0 && labelPosition === 'before' ? (
                <div>
                    <label>
                        {label}
                        {description && description.length > 0 ? (
                            <><br /><br /><em>{description}</em></>
                        ) : <></>}
                    </label>
                </div>
            ) : <></>}
            <div className="checkbox-inputs-wrapper">
                {options.map((el, key) => (
                    <div className="single-checkbox" key={key}>
                        <input
                            type='checkbox'
                            name={name + '_' + key}
                            id={name + '_' + key}
                            onChange={() => onChange(el, (value?.filter(y => y.value === el.value))!.length > 0)}
                            checked={(value?.filter(y => y.value === el.value))!.length > 0}
                            className={className}
                        />
                        <label htmlFor={name + '_' + key}>{el.label}</label>
                    </div>
                ))}
                {/* { other ? (
                    <div className='single-checkbox other-input'>
                        <input
                            type='checkbox'
                            checked={other.checked}
                            readOnly={true}
                            className={className}
                        />
                        <label htmlFor={name + '_other'}>
                            <span className='other-label'>{other.label}</span>
                            <input
                                type="text"
                                value={other.value}
                                name={name + '_other'}
                                id={name + '_other'}
                                className={className}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    if (val.length > 0) {
                                        onOtherChange(true, e.target.value)
                                    } else {
                                        onOtherChange(false, e.target.value)
                                    }
                                }}
                            />
                        </label>
                    </div>
                ) : '' } */}
            </div>
            {label && label.length > 0 && labelPosition === 'after' ? (
                <label>{label}</label>
            ) : <></>}
            { error && (
                <p className='form-error'>{ error }</p>
            ) }
        </div>
    )
}

export default Checkboxes;